// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"20ade289","341":"df82254d","453":"0ef298ba","511":"28fddcc9","960":"dd57444d"}[chunkId] + ".chunk.js";
};